/**
 * Created by roman.kupin on 6/13/2018.
 */

import { SpaceType, getPathForSpace, storedHistory } from 'account-hybrid/common/components/spaces';
import * as fromSpaces from 'account-hybrid/common/components/spaces/store/reducers/spaces.reducer';


export class StateConfig {

    static $inject = ["$stateProvider"];

    constructor($stateProvider) {

        $stateProvider
            .state({
                name: "recommendation",
                url: "/recommendation/{companyCode:[\\d\\w]{2}}/{propertySlug}/{recommendationUUID:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}}",
                data: {
                    requiresAuth: true
                },
                resolve: {
                    companyCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.companyCode;
                    }],
                    propertySlug: ['$stateParams', function ($stateParams) {
                        return $stateParams.propertySlug;
                    }],
                    recommendationUUID: ['$stateParams', function ($stateParams) {
                        return $stateParams.recommendationUUID;
                    }]
                },
                controller: ["companyCode", "propertySlug", 'recommendationUUID', 'SessionService', function (companyCode, propertySlug, recommendationUUID, session) {
                    const userSession = session.get();
                    const spaces = fromSpaces.createSpaces({ companies: userSession.Companies, properties: userSession.Properties, history: storedHistory() });
                    const space = spaces.find(s => s.type === SpaceType.Property && s.slug === propertySlug) ||
                        spaces.find(s => s.type === SpaceType.Mixed && s.slug === `${companyCode}-${propertySlug}`);

                    location.href = !!space ? `${getPathForSpace(space)}/stories/library?recommendationUUID=${recommendationUUID}` : '/home';
                }],
                template:
                    `
                    <div class="ft-loader-orgswitch">
                        <div class="ft-cube-face-single">
                            <div class="ft-content">
                                <div class="ft-loading-message">
                                    Loading <div class="ft2-spinner"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                            `
            });

    }
}
